/* Shopify remains the source of collection membership, facets, ordering, and pagination. */
(function () {
  'use strict';
  if (window.stellarCollectionBrowse) return;
  var roots = new WeakSet();
  var supportedSorts = ['manual', 'most-relevant', 'title-ascending', 'title-descending', 'price-ascending', 'price-descending'];
  var dependentParams = ['filter.p.m.custom.abv', 'filter.p.m.custom.made_from', 'filter.p.m.custom.maturation_aged', 'filter.p.vendor'];
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function canonical(input, root) {
    var url = new URL(input, location.href);
    ['section_id', 'sections', 'filter.v.price.gte', 'filter.v.price.lte', 'filter.v.availability'].forEach(function (key) { url.searchParams.delete(key); });
    if (root.dataset.beverage === 'true') {
      ['filter.p.m.custom.proof', 'filter.v.option.size'].forEach(function (key) { url.searchParams.delete(key); });
    }
    var sort = url.searchParams.get('sort_by');
    if (sort && supportedSorts.indexOf(sort) < 0) url.searchParams.set('sort_by', 'manual');
    return url;
  }

  function dropdowns() {
    if (window.stellarPreviewDropdowns) window.stellarPreviewDropdowns.refresh();
  }

  function media(scope) {
    scope.querySelectorAll('[data-collection-card]').forEach(function (card) {
      if (card.querySelector('[data-stellar-360]')) return;
      if (card.dataset.mediaReady) return;
      card.dataset.mediaReady = 'true';
      var image = card.querySelector('.ssc-display img');
      var stars = card.querySelector('.stellar-media-stars');
      function imageLoaded() { if (stars) stars.hidden = !!(image && image.naturalWidth); }
      if (image) {
        image.addEventListener('load', imageLoaded);
        image.addEventListener('error', function () { image.hidden = true; if (stars) stars.hidden = false; });
        if (image.complete) {
          if (image.naturalWidth) imageLoaded();
          else { image.hidden = true; if (stars) stars.hidden = false; }
        }
      }

    });
  }

  function initialize(root) {
    if (roots.has(root)) return;
    roots.add(root);
    var controller = null;
    var generation = 0;
    var committed = location.href;
    var desiredURL = committed;
    var cleaned = canonical(location.href, root);
    if (!cleaned.searchParams.has('sort_by') && supportedSorts.indexOf(root.dataset.currentSort) < 0) cleaned.searchParams.set('sort_by', 'manual');
    if (cleaned.href !== location.href) {
      cleaned.searchParams.delete('page');
      location.replace(cleaned.href);
      return;
    }

    function status(text) {
      var node = root.querySelector('[data-collection-status]');
      if (node) node.textContent = text;
    }
    function busy(value, append) {
      root.setAttribute('aria-busy', String(value));
      root.classList.toggle('is-loading', value);
      var more = root.querySelector('[data-collection-more]');
      if (more) {
        if (value) more.setAttribute('aria-disabled', 'true');
        else more.removeAttribute('aria-disabled');
      }
      if (value) status(append ? 'Loading more choices.' : 'Updating collection.');
    }
    function restoreFocus(id) {
      if (!id) return;
      var focus = document.getElementById(id);
      if (!focus) focus = document.getElementById(id.replace(/-dropdown-trigger$/, ''));
      if (!focus || !root.contains(focus) || focus.hidden || focus.disabled) focus = root.querySelector('.cf-tools summary');
      if (focus) focus.focus({ preventScroll: true });
    }

    async function load(input, options) {
      options = options || {};
      var url = canonical(input, root);
      if (url.origin !== location.origin || url.pathname !== new URL(root.dataset.collectionUrl, location.origin).pathname) { location.assign(url.href); return; }
      if (!options.append) desiredURL = url.href;
      if (controller) controller.abort();
      controller = new AbortController();
      var request = ++generation;
      var panel = root.querySelector('.cf-tools');
      var wasOpen = panel && panel.open;
      var focusId = options.focus || (root.contains(document.activeElement) ? document.activeElement.id : '');
      var appendedFocus = null;
      busy(true, options.append);
      var sectionURL = new URL(url.href);
      sectionURL.searchParams.set('section_id', root.dataset.section);
      try {
        var response = await fetch(sectionURL.href, { signal: controller.signal, credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error('Collection response failed');
        var html = await response.text();
        if (request !== generation) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var updated = doc.querySelector('[data-stellar-collection]');
        var nextInner = updated && updated.querySelector('[data-coll-inner]');
        if (!nextInner || updated.dataset.section !== root.dataset.section) throw new Error('Collection response incomplete');
        if (options.append) {
          var grid = root.querySelector('[data-collection-grid]');
          var nextGrid = updated.querySelector('[data-collection-grid]');
          if (!grid || !nextGrid) throw new Error('Collection cards missing');
          var present = new Set(Array.prototype.map.call(grid.children, function (card) { return card.dataset.handle; }));
          Array.prototype.slice.call(nextGrid.children).forEach(function (card) { if (!present.has(card.dataset.handle)) { present.add(card.dataset.handle); grid.append(card); if (!appendedFocus) appendedFocus = card.querySelector('a'); } });
          var moreWrap = root.querySelector('[data-more-wrap]');
          var nextMore = updated.querySelector('[data-more-wrap]');
          if (moreWrap && nextMore) moreWrap.replaceWith(nextMore);
          status(grid.children.length + ' choices shown.');
        } else {
          root.querySelectorAll('[data-collection-card]').forEach(function (card) { if (card._stellarStopFilm) card._stellarStopFilm(); });
          root.querySelector('[data-coll-inner]').replaceWith(nextInner);
          root.dataset.beverage = updated.dataset.beverage;
          root.dataset.currentSort = updated.dataset.currentSort;
          var nextPanel = root.querySelector('.cf-tools');
          if (nextPanel) nextPanel.open = wasOpen;
          if (options.history !== false && url.href !== committed) history.pushState({ stellarCollection: true }, '', url.href);
          committed = url.href;
        }
        dropdowns();
        media(root);
        if (options.append && appendedFocus) appendedFocus.focus({ preventScroll: true });
        else if (!options.append) restoreFocus(focusId);
        root.dispatchEvent(new CustomEvent('stellar:collection:updated', { bubbles: true }));
      } catch (error) {
        if (error.name === 'AbortError' || request !== generation) return;
        status('Opening the collection.');
        location.assign(url.href);
      } finally {
        if (request === generation) busy(false, options.append);
      }
    }

    root.addEventListener('change', function (event) {
      var select = event.target.closest('[data-collection-filter], [data-collection-sort]');
      if (!select || !root.contains(select)) return;
      var url = canonical(desiredURL, root);
      url.searchParams.delete('page');
      if (select.name === 'filter.p.product_type') dependentParams.forEach(function (param) { url.searchParams.delete(param); });
      url.searchParams.delete(select.name);
      if (select.value) url.searchParams.set(select.name, select.value);
      load(url.href, { focus: select.id + '-dropdown-trigger' });
    });
    root.addEventListener('click', function (event) {
      var link = event.target.closest('[data-collection-reset], [data-remove-filter], [data-collection-more]');
      if (!link || !root.contains(link) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      var append = link.hasAttribute('data-collection-more');
      if (append && root.getAttribute('aria-busy') === 'true') return;
      var url = canonical(link.href, root);
      if (!append) url.searchParams.delete('page');
      load(url.href, { append: append, focus: append ? '' : 'category-dropdown-trigger' });
    });
    root.addEventListener('submit', function (event) {
      if (!event.target.matches('[data-collection-form]')) return;
      event.preventDefault();
      var panel = root.querySelector('.cf-tools');
      if (panel) { panel.open = false; panel.querySelector('summary').focus({ preventScroll: true }); }
    });
    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || event.defaultPrevented) return;
      var panel = event.target.closest('.cf-tools');
      if (panel && panel.open) { panel.open = false; panel.querySelector('summary').focus({ preventScroll: true }); }
    });
    window.addEventListener('popstate', function () { load(location.href, { history: false }); });
    root.dataset.collectionReady = 'true';
    media(root);
    dropdowns();
  }

  function refresh() { document.querySelectorAll('[data-stellar-collection]').forEach(initialize); }
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) document.querySelectorAll('[data-collection-card]').forEach(function (card) { if (card._stellarStopFilm) card._stellarStopFilm(); });
  });
  window.stellarCollectionBrowse = { refresh: refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
  document.addEventListener('shopify:section:load', refresh);
})();
